import { useMemo } from 'react';

import { useErrorMsg } from './useErrorMsg';
import { useUserProfile } from './useUserProfile';

export function useUserInfo() {
  const { profile, mutate, loading, is_copy_pro_sub_account } =
    useUserProfile();
  const { msgError } = useErrorMsg(mutate);
  const userInfo = useMemo(() => {
    let email_verified = true,
      vague_email = '',
      mobile_verified = false,
      vague_mobile = '',
      has_google2fa = false,
      is_submember = false,
      parent_verify_method = '',
      country_code = '',
      parent_member_id = 0,
      vague_email_v2 = '',
      member_tag: any = {},
      id = 0,
      unified_account = 0,
      demo_id = 0;
    if (profile && profile.result) {
      email_verified = profile.result.email_verified;
      vague_email = profile.result.vague_email;
      mobile_verified = profile.result.mobile_verified;
      vague_mobile = profile.result.vague_mobile;
      has_google2fa = profile.result.has_google2fa;
      is_submember = profile.result.is_submember;
      parent_verify_method = profile.result.parent_verify_method;
      country_code = profile.result.country_code;
      parent_member_id = profile.result.parent_member_id;
      vague_email_v2 = profile.result.vague_email_v2;
      member_tag = profile.result.member_tag;
      id = profile.result.id;
      unified_account = profile.result.unified_account;
      demo_id = profile.result.demo_id;
    }
    return {
      email_verified,
      vague_email,
      mobile_verified,
      vague_mobile,
      has_google2fa,
      is_submember,
      parent_verify_method,
      country_code,
      parent_member_id,
      vague_email_v2,
      member_tag,
      id,
      unified_account,
      demo_id,
      is_copy_pro_sub_account,
    };
  }, [profile, is_copy_pro_sub_account]);

  return {
    user: userInfo,
    loading,
    msgError,
  };
}
